import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import tavernAppIcon from '../../assets/branding/tavern-app-icon.png';

const BrandLogo = ({
  compact = false,
  emblemSize = 44,
  onClick,
  variant,
}) => {
  const { t } = useTranslation();
  const resolvedVariant = variant || (compact ? 'icon' : 'horizontal');
  const tagline = t('brand.tagline');
  const logoAlt = t('brand.logoAlt', { tagline });

  if (resolvedVariant === 'stacked') {
    return (
      <Stack
        aria-label={onClick ? 'Switch The Tavern environment' : undefined}
        component={onClick ? 'button' : 'div'}
        onClick={onClick}
        type={onClick ? 'button' : undefined}
        spacing={compact ? 0.75 : 1.25}
        alignItems="center"
        sx={{
          appearance: 'none',
          background: 'transparent',
          border: 0,
          color: 'inherit',
          cursor: onClick ? 'pointer' : 'default',
          font: 'inherit',
          m: 0,
          p: 0,
          width: '100%',
          py: compact ? 0 : 0.5,
          WebkitTapHighlightColor: 'transparent',
          '&:focus-visible': onClick
            ? {
                outline: '3px solid rgba(215, 160, 75, 0.62)',
                outlineOffset: 4,
                borderRadius: 2,
              }
            : undefined,
        }}
      >
        <Box
          component="img"
          src={tavernAppIcon}
          alt=""
          sx={{
            width: compact ? { xs: 78, sm: 96 } : { xs: 104, sm: 118 },
            height: compact ? { xs: 78, sm: 96 } : { xs: 104, sm: 118 },
            borderRadius: '22%',
            boxShadow: '0 20px 42px -30px rgba(5, 34, 31, 0.72)',
          }}
        />
        <Box sx={{ textAlign: 'center', minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: '"Cinzel", Georgia, serif',
              fontSize: compact
                ? { xs: '1.5rem', sm: '1.92rem' }
                : { xs: '1.88rem', sm: '2.22rem' },
              fontWeight: 800,
              lineHeight: 0.95,
              color: 'text.primary',
              letterSpacing: 0,
            }}
          >
            The Tavern
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'secondary.dark',
              letterSpacing: compact ? { xs: '0.14em', sm: '0.2em' } : { xs: '0.2em', sm: '0.24em' },
              mt: compact ? 0.25 : 0.5,
              textAlign: 'center',
              fontSize: compact ? { xs: '0.62rem', sm: '0.75rem' } : undefined,
            }}
          >
            {tagline}
          </Typography>
        </Box>
      </Stack>
    );
  }

  if (resolvedVariant === 'horizontal') {
    return (
      <Stack
        direction="row"
        spacing={1.1}
        alignItems="center"
        sx={{
          minWidth: 0,
          maxWidth: '100%',
        }}
      >
        <Box
          component="img"
          src={tavernAppIcon}
          alt=""
          sx={{
            width: { xs: 36, sm: 48 },
            height: { xs: 36, sm: 48 },
            flex: '0 0 auto',
            borderRadius: '22%',
            boxShadow: '0 12px 26px -20px rgba(5, 34, 31, 0.72)',
          }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            aria-label={logoAlt}
            sx={{
              fontFamily: '"Cinzel", Georgia, serif',
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.12rem', lg: '1.28rem' },
              fontWeight: 800,
              lineHeight: 1,
              color: 'text.primary',
              whiteSpace: 'nowrap',
              letterSpacing: 0,
            }}
          >
            The Tavern
          </Typography>
          <Typography
            variant="subtitle2"
            sx={{
              color: 'secondary.dark',
              letterSpacing: { xs: '0.08em', sm: '0.12em', md: '0.16em' },
              whiteSpace: 'nowrap',
              fontSize: { xs: '0.46rem', sm: '0.52rem', md: '0.56rem', lg: '0.6rem' },
            }}
          >
            {tagline}
          </Typography>
        </Box>
      </Stack>
    );
  }

  return (
    <Box
      component="img"
      src={tavernAppIcon}
      alt="The Tavern"
      sx={{
        width: emblemSize,
        height: emblemSize,
        display: 'block',
        flex: '0 0 auto',
        borderRadius: '22%',
        filter: 'drop-shadow(0 8px 14px rgba(5, 34, 31, 0.22))',
      }}
    />
  );
};

export default BrandLogo;
